<template>
  <div class="bg">
   <!-- <img :src="require('../../../assets/eventBanner/'+ programId + '.jpg')" alt="" class="banner-img"> -->
    <img :src="imgSrc" alt="" class="banner-img">
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'eventSwiper',
  components: {},
  mounted () {
  },
  data () {
    return {
      programId: this.$route.query.programId,
      matchFun: matchFun,
      imgSrc: require('../../../assets/eventBanner/1.jpg')
    }
  },
  created () {
    this.imgSrc = require('../../../assets/eventBanner/' + this.matchFun.getEventBg(this.programId) + '.jpg')
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.bg{
    width: 100%;
    background-color: green;
}
.banner-img{
  width: 100%;
  height: 470px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/home/Swiper.vue